import moment from "moment-business-days-sk";

// Every date the admin shows: the month's short name, the day and the year (CVIEW-R12). The
// value is a calendar date, so it is read as UTC and never shifts a day with the time zone.
export const formatAdminDate = (value: string): string =>
  moment.utc(value).locale("en").format("MMM D, YYYY");

export const formatMonthAndDay = (value: string): string =>
  moment.utc(value).locale("en").format("MMM D");

// Some browsers put a narrow no-break space before AM or PM.
const narrowNoBreakSpace = String.fromCharCode(0x202f);

const easternTime = new Intl.DateTimeFormat("en-US", {
  timeZone: "America/New_York",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
});

// A moment in Eastern time, summer or winter, such as "Sep 29, 4:12 PM ET" (REDOUI-R56).
export const formatAdminDateTime = (value: string): string =>
  `${easternTime.format(new Date(value)).split(narrowNoBreakSpace).join(" ")} ET`;

// A range of dates (CVIEW-R4): the year once when both dates fall in it, both years when the
// range crosses a year, and one date when the range has no end.
export const formatAdminDateRange = (from: string, to?: string): string => {
  if (!to) return formatAdminDate(from);

  const isInOneYear = moment.utc(from).year() === moment.utc(to).year();

  return isInOneYear
    ? `${formatMonthAndDay(from)} – ${formatAdminDate(to)}`
    : `${formatAdminDate(from)} – ${formatAdminDate(to)}`;
};
